import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AddTask from './components/AddTask';
import TaskList from './components/TaskList';

const App = () => {
  const [tasks, setTasks] = useState([]);

  // Fetch tasks from the backend
  useEffect(() => {
    axios.get('http://localhost:8080/api/tasks')
      .then(response => setTasks(response.data))
      .catch(error => console.error("There was an error fetching tasks:", error));
  }, []);

  // Handle adding new task
  const handleAddTask = (task) => {
    axios.post('http://localhost:8080/api/tasks/add', task)
      .then(response => {
        setTasks([...tasks, response.data]);
      })
      .catch(error => console.error("There was an error adding the task:", error));
  };

  // Handle deleting a task
  const handleDeleteTask = (taskId) => {
    axios.delete(`http://localhost:8080/api/tasks/${taskId}`)
      .then(() => {
        setTasks(tasks.filter(task => task.id !== taskId));
      })
      .catch(error => console.error("There was an error deleting the task:", error));
  };

  // Handle toggling task completion
  const handleToggleComplete = (taskId) => {
    const task = tasks.find(t => t.id === taskId);
    const updatedTask = { ...task, completed: !task.completed };

    axios.put(`http://localhost:8080/api/tasks/${taskId}`, updatedTask)
      .then(response => {
        setTasks(tasks.map(t => t.id === taskId ? response.data : t));
      })
      .catch(error => console.error("There was an error updating the task:", error));
  };

  return (
    <div>
      <h1>Task Manager</h1>
      <AddTask onAdd={handleAddTask} />
      <TaskList tasks={tasks} onDelete={handleDeleteTask} onToggleComplete={handleToggleComplete} />
    </div>
  );
};

export default App;
